import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(() => import("../components/transcript/setup/main"));

const TranscriptSetup = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default TranscriptSetup;